import ym from 'react-yandex-metrika';

import { buildConfig } from 'packages/buildConfig';

import { YandexMetrikaEvent } from '../events';

export const getYMEventPayload = (event: YandexMetrikaEvent) => {
  return 'payload' in event ? event.payload : undefined;
};

export const emitYMEvent = (event: YandexMetrikaEvent) => {
  // Нельзя вызывать события метрики, если она не инициализирована
  if (!buildConfig.config || buildConfig.config.YM_ENABLED === false) {
    return;
  }

  const payload = 'payload' in event ? event.payload : undefined;
  ym('reachGoal', event.type, payload);
};
